import React from 'react';

const imgFrame765 = "/images/assets/ed06679ec65169f3a1c05f796f844895f97a0423.png";
const imgFrame763 = "/images/assets/35e6552a8a34bbb579e4f2c16901cd5e771d596a.png";

function Frame52() {
  return (
    <div className="flex flex-col gap-2 items-start w-full">
      <div className="font-['Roboto:Medium',sans-serif] font-medium leading-tight md:leading-[40px] lg:leading-[48px] text-3xl md:text-4xl lg:text-[48px] text-black" style={{ fontVariationSettings: "'wdth' 100" }}>
        <p className="mb-0" style={{ fontVariationSettings: "'wdth' 100" }}>{`About `}</p>
        <p className="text-[#3a599c]" style={{ fontVariationSettings: "'wdth' 100" }}>HyreLancer</p>
      </div>
    </div>
  );
}

function Frame7() {
  return (
    <div className="flex flex-col gap-4 md:gap-6 items-start justify-center w-full">
      <Frame52 />
      <div className="font-['Roboto:Regular',sans-serif] font-normal leading-relaxed text-sm md:text-base text-black w-full max-w-[795px]" style={{ fontVariationSettings: "'wdth' 100" }}>
        <p className="mb-0">HyreLancer is a trusted freelancing platform that connects individuals and organizations with top-tier talent across a wide range of industries and services.</p>
        <p className="mb-0">Whether you're a business looking for a marketing expert, an individual hiring a makeup artist for your wedding, or someone seeking a personal fitness coach — HyreLancer makes it simple to find and collaborate with the right professional.</p>
        <p>Our platform bridges the gap between talent and opportunity, making hiring flexible, transparent, and efficient for everyone.</p>
      </div>
    </div>
  );
}

function Frame13() {
  return (
    <div className="flex flex-col h-full items-end justify-between text-white p-2 sm:p-3 lg:p-3 xl:p-3.5 2xl:p-4">
      <p className="font-['Roboto:Medium',sans-serif] font-medium leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-[44px] 2xl:text-5xl text-center whitespace-nowrap" style={{ fontVariationSettings: "'wdth' 100" }}>200+</p>
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-4 sm:leading-5 lg:leading-5 xl:leading-[22px] 2xl:leading-6 text-[10px] sm:text-xs md:text-sm lg:text-sm xl:text-[15px] 2xl:text-base text-right" style={{ fontVariationSettings: "'wdth' 100" }}>Happy Customers</p>
    </div>
  );
}

function Frame67() {
  return (
    <div className="flex h-[140px] sm:h-[160px] md:h-[180px] lg:h-[200px] xl:h-[240px] 2xl:h-[297px] items-center justify-end overflow-hidden relative rounded-2xl w-full">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none rounded-2xl">
        <img alt="" className="absolute w-full h-full object-cover rounded-2xl" src={imgFrame765} />
        <div className="absolute bg-[rgba(0,0,0,0.39)] inset-0 rounded-2xl" />
      </div>
      <div className="relative z-10 w-full">
        <Frame13 />
      </div>
    </div>
  );
}

function Frame14() {
  return (
    <div className="flex flex-col h-full items-end justify-between text-white p-2 sm:p-3 lg:p-3 xl:p-3.5 2xl:p-4">
      <p className="font-['Roboto:Medium',sans-serif] font-medium leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-[44px] 2xl:text-5xl text-center whitespace-nowrap" style={{ fontVariationSettings: "'wdth' 100" }}>+1K</p>
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-4 sm:leading-5 lg:leading-5 xl:leading-[22px] 2xl:leading-6 text-[10px] sm:text-xs md:text-sm lg:text-sm xl:text-[15px] 2xl:text-base text-right" style={{ fontVariationSettings: "'wdth' 100" }}>Daily services at your Doorsteps</p>
    </div>
  );
}

function Frame63() {
  return (
    <div className="bg-[#3a599c] flex h-[140px] sm:h-[160px] md:h-[180px] lg:h-[200px] xl:h-[240px] 2xl:h-[297px] items-center justify-end overflow-hidden relative rounded-2xl w-full">
      <Frame14 />
    </div>
  );
}

function Frame15() {
  return (
    <div className="flex flex-col h-full items-end justify-between text-white p-2 sm:p-3 lg:p-3 xl:p-3.5 2xl:p-4">
      <p className="font-['Roboto:Medium',sans-serif] font-medium leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-[44px] 2xl:text-5xl text-center whitespace-nowrap" style={{ fontVariationSettings: "'wdth' 100" }}>+1K</p>
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-4 sm:leading-5 lg:leading-5 xl:leading-[22px] 2xl:leading-6 text-[10px] sm:text-xs md:text-sm lg:text-sm xl:text-[15px] 2xl:text-base text-right" style={{ fontVariationSettings: "'wdth' 100" }}>Happy Customers</p>
    </div>
  );
}

function Frame66() {
  return (
    <div className="bg-black flex h-[140px] sm:h-[160px] md:h-[180px] lg:h-[200px] xl:h-[240px] 2xl:h-[297px] items-center justify-end overflow-hidden relative rounded-2xl w-full">
      <Frame15 />
    </div>
  );
}

function Frame65() {
  return (
    <div className="h-[140px] sm:h-[160px] md:h-[180px] lg:h-[200px] xl:h-[240px] 2xl:h-[297px] relative rounded-2xl w-full">
      <img alt="" className="absolute inset-0 w-full h-full object-cover pointer-events-none rounded-2xl" src={imgFrame763} />
    </div>
  );
}

function Frame72() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 gap-4 md:gap-6 lg:gap-6 xl:gap-8 w-full lg:max-w-[550px] xl:max-w-[600px] 2xl:max-w-[650px]">
      <Frame67 />
      <Frame63 />
      <Frame66 />
      <Frame65 />
    </div>
  );
}

export default function AboutSection() {
  return (
    <div className="relative w-full py-8 md:py-12 lg:py-16">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 md:gap-12 lg:gap-8 xl:gap-12 2xl:gap-16 px-4 md:px-8 lg:px-12 xl:px-20 2xl:px-32 max-w-[1920px] mx-auto">
        <Frame7 />
        <div className="w-full lg:w-auto flex-shrink-0">
          <Frame72 />
        </div>
      </div>
    </div>
  );
}

